






















































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  id: any
  isNew: boolean
  student: any
  errors: any[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      id: null,
      isNew: context.root.$route.path.indexOf("new") != -1,
      student: {
        student_no_character: "",
        grade: "",
        room_name: "",
        student_no: "",
        name: "",
        email: "",
      },
      errors: [],
    });

    // 登録ボタン押下
    const entryClick = async () => {

      if(!validate() || !window.confirm("生徒情報を登録します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_edit`, {student: state.student}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    // 更新ボタン押下
    const updateClick = async () => {

      if(!validate() || !window.confirm("生徒情報を更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_edit/update/${state.id}`, {student: state.student}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    // バリデーション
    const validate = () => {
      state.errors = [];

      if(state.student.student_no_character === ''){
        state.errors.push("学籍番号は必須です。");
      }

      if(state.student.grade === ''){
        state.errors.push("学年は必須です。");
      }

      if(state.student.room_name === ''){
        state.errors.push("クラスは必須です。");
      }

      if(state.student.student_no === ''){
        state.errors.push("出席番号は必須です。");
      }else{
        if(Math.sign(state.student.student_no) != 1){
          state.errors.push("出席番号は半角数字で入力してください。");
        }
      }

      if(state.student.name === ''){
        state.errors.push("氏名は必須です。");
      }

      if(state.student.email){
        var regex = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
        if (!regex.test(state.student.email)) {
          state.errors.push("メールアドレスのフォーマットが誤っています。");
        }
      }

      return state.errors.length == 0;
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      if(!state.isNew){
        state.id = context.root.$route.params.id;

        // 編集の場合、生徒情報をapiから取得
        context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
        await http.get(`/api/teacher/student_edit/?id=${state.id}`).then(response => {
          var students = response.data.students;
          state.student.student_no_character = students[0].student_no_character;
          state.student.grade = students[0].grade;
          state.student.room_name = students[0].room_name;
          state.student.student_no = students[0].student_no;
          state.student.name = students[0].name;
          state.student.email = students[0].email;
        })
        .catch(error=>{
          // 後続処理不能のため一覧に戻る
          if(error.response.status == 422){
            alert(`生徒情報の取得処理に失敗しました。生徒一覧に戻ります。\n${error.response.data.errors[0]}`);
          }else{
            alert(`生徒情報の取得処理に失敗しました。生徒一覧に戻ります。`);
          }
          window.history.back();
        });
        context.root.$store.dispatch("hideOverlay");
      }
    })

    return {
      ...toRefs(state),
      entryClick,
      updateClick,
    }
  }
})
